module.exports = __webpack_public_path__ + "4fe62a97601b95d63159b4f3e36aa872.jpg";